import React, { useState, useEffect } from "react";
import DiscrepancyModal from "../operator/DiscrepancyModal";
import { CiCircleCheck } from "react-icons/ci";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../loader/Loader";
export default function LogoutConfirmModal({ show, onClose }) {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [totalproduction, setTtotalproduction] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        if (show) {
            fetchtotalproduction();
        }
    }, [show]);
    const fetchtotalproduction = async () => {
        const token = getAuthToken();
        if (!token) return;
        try {
            setLoading(true);
            const response = await axios.get(
                `${config.API}/operator/totalproduction`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            setTtotalproduction(response?.data || {});
        } catch (err) {
            console.error(err);
            setTtotalproduction({});
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        const token = getAuthToken();
        if (!token) {
            toast.error("Authentication token missing!");
            return;
        }
        try {
            const response = await axios.post(
                `${config.API}/operator/acceptsummary`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const { success, message } = response.data;
            if (success) {
                toast.success(message || "Shift closed successfully!");
                localStorage.removeItem("user");
                navigate("/");
            } else {
                toast.error(message || "Something went wrong!");
            }
        } catch (err) {
            toast.error("Failed to submit summary!");
        }
    };
    if (!show) return null;
    return (
        <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
            <div
                className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content font_family">
                    <header className="d-flex justify-content-between align-items-start position-relative">
                        <div className="mt-3 ms-3">
                            <h5 className="fw-bold mb-1 font_shift">End of Shift Summary</h5>
                            <p className="mb-0 text-muted">
                                Date: {new Date().toLocaleDateString("en-GB")}
                            </p>
                            <p className="mb-0 text-muted">Shift: Morning</p>
                        </div>
                        <div className="text-end mt-5 me-3">
                            <h5 className="fw-semibold mb-0">
                                {parseFloat(totalproduction?.productivity || 0).toFixed(2)}%
                            </h5>
                            <small className="text-muted">Efficiency</small>
                        </div>
                        <button
                            type="button"
                            className="btn-close position-absolute top-0 end-0 m-3"
                            aria-label="Close"
                            onClick={onClose}
                        ></button>
                    </header>
                    <div className="modal-body">
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                <div>
                                    <h6 className="fw-semibold">Production Summary | {totalproduction?.product}</h6>
                                    <div className="text-end small">
                                        {totalproduction?.total_production} /{" "}
                                        {totalproduction?.daily_target}
                                    </div>
                                    <div className="progress mb-3" style={{ height: "6px" }}>
                                        <div
                                            className="progress-bar bg-primary"
                                            style={{
                                                width: `${totalproduction?.daily_target > 0
                                                    ? (totalproduction?.total_production /
                                                        totalproduction?.daily_target) *
                                                    100
                                                    : 0
                                                    }%`,
                                            }}
                                        />
                                    </div>
                                    <div className="row g-3 text-center">
                                        <div className="col-md-4 endShiftBox">
                                            <div className="card bg-light p-3 h-100 border-0">
                                                <h5 className="fw-bold mb-0">{totalproduction?.total_production}</h5>
                                                <small className="text-muted">Units Produced</small>
                                            </div>
                                        </div>
                                        <div className="col-md-4 endShiftBox">
                                            <div className="card bg-light p-3 h-100 border-0">
                                                <h5 className="fw-bold mb-0">{totalproduction?.daily_target}</h5>
                                                <small className="text-muted">Target Units</small>
                                            </div>
                                        </div>
                                        <div className="col-md-4 endShiftBox">
                                            <div className="card bg-light p-3 h-100 border-0">
                                                <h5 className="fw-bold mb-0">{totalproduction?.total_nc}</h5>
                                                <small className="text-muted">Non-Conformities</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            className="btn btn-outline-secondary"
                            onClick={() => setShowModal(true)}
                        >
                            <AiOutlineExclamationCircle /> Report Discrepancy
                        </button>

                        <button className="btn btn-primary" onClick={handleSubmit} disabled={showModal}>
                            <CiCircleCheck /> Accept Summary
                        </button>
                    </div>
                </div>
            </div>
            <DiscrepancyModal
                show={showModal}
                handleClose={() => setShowModal(false)}
            />
        </div>
    );
}


